(() => {
  const initialize = () => {
    document.querySelectorAll('[data-vq-fit]').forEach(root => {
      if (root.dataset.fitReady) return;
      root.dataset.fitReady = 'true';
      const inputs = Array.from(root.querySelectorAll('input[type="radio"]'));
      const apply = input => {
        root.querySelector('[data-fit-answer]').textContent = input.dataset.copy;
        root.querySelector('h2').textContent = input.dataset.heading;
        const property = root.querySelector('[data-fit-property]');
        property.value = input.value;
        property.disabled = false;
      };
      inputs.forEach(input => input.addEventListener('change', () => apply(input)));
      const fromLink = () => {
        const surface = new URL(window.location.href).searchParams.get('surface');
        const selected = inputs.find(input => input.value === surface || '#' + input.value === window.location.hash);
        if (selected) {
          selected.checked = true;
          apply(selected);
        }
      };
      fromLink();
      window.addEventListener('hashchange', fromLink);
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
